import React from "react";
import PixnetLogo from "../images/footer_pixnet.svg";

const Footer = () => {
    return (
        <footer className="footer">
            <p>
                Copyright © 2023
                <img src={PixnetLogo} width={56} height={17} alt="pixnet-logo" />
                優像數位媒體科技 ( 股 ) 公司
            </p>
        </footer>
    );
};

export default Footer;
